const usePlurallTracker = () => {
  const sendTracker = (event, params) =>
    (window.PLURALL_TRACKER || window.tracker)?.track(event, { ...params })

  return { sendTracker }
}

export { usePlurallTracker }
